export default "__VITE_ASSET__Bu$CVxu0__"